module.exports = __webpack_public_path__ + "statics/img/cate1-3@2x.f8b6c126.png";